export interface BrandLogo {
  name: string;
  domain: string;
}

export const brandLogos: BrandLogo[] = [
  { name: 'Yuno', domain: 'y.uno' },
  { name: 'Stripe', domain: 'stripe.com' },
  { name: 'dLocal', domain: 'dlocal.com' },
  { name: 'Rappi', domain: 'rappi.com' },
  { name: 'GoFundMe', domain: 'gofundme.com' },
  { name: 'Carrefour', domain: 'carrefour.com' },
  { name: 'Amazon', domain: 'amazon.com' },
  { name: 'Google', domain: 'google.com' },
];

export const logoSrc = (domain: string) => `https://www.google.com/s2/favicons?domain=${domain}&sz=128`;
